export const ClosedMaxHeight = '0px';
export const focusContentWrapper = (expanded, focusOnExpanded, contentWrapper) => {
    if (expanded && focusOnExpanded) {
        contentWrapper.focus();
    }
};
export const handleTransitionEnd = (expanded, focusOnExpanded, contentWrapper, e, setIsFullyClosed, callback) => {
    if (e.target !== contentWrapper ||
        (e.target === contentWrapper && e.propertyName !== 'grid-template-rows')) {
        return;
    }
    focusContentWrapper(expanded, focusOnExpanded, contentWrapper);
    if (!expanded) {
        setIsFullyClosed(true);
    }
    if (callback) {
        callback(e, expanded);
    }
};
export const getTabIndex = (expanded, focusOnExpanded) => {
    return expanded && focusOnExpanded ? 0 : void 0; // Attributes with `undefined` values are not rendered so they are preferred over `null`.
};
